import { render, staticRenderFns } from "./ProvidingDataAgreementDialog.vue?vue&type=template&id=4014bafa&scoped=true&"
import script from "./ProvidingDataAgreementDialog.vue?vue&type=script&lang=ts&"
export * from "./ProvidingDataAgreementDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4014bafa",
  null
  
)

export default component.exports